import { BROADCAST_VOCABULARIES } from './broadcast.js';
import { CASE_MANAGEMENT_VOCABULARIES } from './case-management.js';
import { CENTRAL_DESK_VOCABULARIES } from './central-desk.js';
import { DRIVER_WALLET_VOCABULARIES } from './driver-wallet.js';
import { FOOD_CART_VOCABULARIES } from './food-cart.js';
import { FOOD_CATALOG_VOCABULARIES } from './food-catalog.js';
import { INCENTIVE_FUND_VOCABULARIES } from './incentive-fund.js';
import { DRIVER_BOOST_VOCABULARIES } from './driver-boost.js';
import { INCENTIVE_CONTROLLER_VOCABULARIES } from './incentive-controller.js';
import { EARNINGS_GUARANTEE_VOCABULARIES } from './earnings-guarantee.js';
import { INCENTIVES_VOCABULARIES } from './incentives.js';
import { MERCHANT_ANALYTICS_VOCABULARIES } from './merchant-analytics.js';
import { MERCHANT_FINANCE_VOCABULARIES } from './merchant-finance.js';
import { MERCHANT_PROMOTIONS_VOCABULARIES } from './merchant-promotions.js';
import { OPS_PLATFORM_VOCABULARIES } from './ops-platform.js';
import { PRICING_AUTOMATION_VOCABULARIES } from './pricing-automation.js';
import { PRIVACY_VOCABULARIES } from './privacy.js';
import { RBAC_PERMISSION_VOCABULARIES } from './rbac-permission.js';
import { RBAC_VOCABULARIES } from './rbac.js';
import { REALTIME_VOCABULARIES } from './realtime.js';
import { REPUTATION_VOCABULARIES } from './reputation.js';
import { REQUEST_GROUP_VOCABULARIES } from './request-group.js';
import { RIDE_COLLABORATION_VOCABULARIES } from './ride-collaboration.js';
import { RIDE_REQUEST_VOCABULARIES } from './ride-request.js';
import { RISK_VOCABULARIES } from './risk.js';
import { SERVICE_CATEGORIES_VOCABULARIES } from './service-categories.js';
import { SERVICE_CENTER_GOVERNANCE_VOCABULARIES } from './service-center-governance.js';
import { SERVICE_CENTER_VOCABULARIES } from './service-center.js';
import { SUPPORT_VOCABULARIES } from './support.js';
import { VEHICLES_VOCABULARIES } from './vehicles.js';
import { VENUE_QUEUE_VOCABULARIES } from './venue-queue.js';
import { PROBLEM_SHARED_B_VOCABULARIES } from './problem-shared-b.js';
/** Slice b of the catalog (D577): the domain files one build front owns register here (keeps fronts off each other's files). */
export const SLICE_B = [
    ...BROADCAST_VOCABULARIES,
    ...CASE_MANAGEMENT_VOCABULARIES,
    ...CENTRAL_DESK_VOCABULARIES,
    ...DRIVER_WALLET_VOCABULARIES,
    ...FOOD_CART_VOCABULARIES,
    ...FOOD_CATALOG_VOCABULARIES,
    ...INCENTIVE_FUND_VOCABULARIES,
    ...DRIVER_BOOST_VOCABULARIES,
    ...INCENTIVE_CONTROLLER_VOCABULARIES,
    ...EARNINGS_GUARANTEE_VOCABULARIES,
    ...INCENTIVES_VOCABULARIES,
    ...MERCHANT_ANALYTICS_VOCABULARIES,
    ...MERCHANT_FINANCE_VOCABULARIES,
    ...MERCHANT_PROMOTIONS_VOCABULARIES,
    ...OPS_PLATFORM_VOCABULARIES,
    ...PRICING_AUTOMATION_VOCABULARIES,
    ...PRIVACY_VOCABULARIES,
    ...RBAC_PERMISSION_VOCABULARIES,
    ...RBAC_VOCABULARIES,
    ...REALTIME_VOCABULARIES,
    ...REPUTATION_VOCABULARIES,
    ...REQUEST_GROUP_VOCABULARIES,
    ...RIDE_COLLABORATION_VOCABULARIES,
    ...RIDE_REQUEST_VOCABULARIES,
    ...RISK_VOCABULARIES,
    ...SERVICE_CATEGORIES_VOCABULARIES,
    ...SERVICE_CENTER_GOVERNANCE_VOCABULARIES,
    ...SERVICE_CENTER_VOCABULARIES,
    ...SUPPORT_VOCABULARIES,
    ...VEHICLES_VOCABULARIES,
    ...VENUE_QUEUE_VOCABULARIES,
    ...PROBLEM_SHARED_B_VOCABULARIES,
];
//# sourceMappingURL=slice-b.js.map